import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Check } from 'lucide-react';

export const AdhesionPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    navigate('/login');
    return null;
  }

  const plans = [
    {
      name: 'Gratuit',
      price: '0 CDF',
      period: '/mois',
      features: [
        'Accès aux vidéos publiques',
        'Publicités',
        'Qualité SD',
        'Commentaires et likes'
      ],
      current: true
    },
    {
      name: 'Premium',
      price: '5000 CDF',
      period: '/mois',
      features: [
        'Accès illimité',
        'Sans publicités',
        'Qualité HD/4K',
        'Téléchargement offline',
        'Support prioritaire'
      ],
      recommended: true
    },
    {
      name: 'Créateur',
      price: '10000 CDF',
      period: '/mois',
      features: [
        'Tous les avantages Premium',
        'Upload illimité',
        'Analytics avancés',
        'Monétisation',
        'Support dédié'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background pt-24 pb-12">
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Plans d'adhésion</h1>
          <p className="text-lg text-muted-foreground">Choisissez le plan qui vous convient</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`bg-card border-2 rounded-xl p-6 relative ${
                plan.recommended ? 'border-accent' : 'border-border'
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
                  Recommandé
                </div>
              )}
              
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
                <div className="flex items-baseline justify-center gap-1">
                  <span className="text-4xl font-bold">{plan.price}</span>
                  <span className="text-muted-foreground">{plan.period}</span>
                </div>
              </div>

              <ul className="space-y-3 mb-6">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2">
                    <Check className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                disabled={plan.current}
                className={`w-full py-2 rounded-lg font-medium transition-opacity ${
                  plan.current
                    ? 'bg-muted text-muted-foreground cursor-not-allowed'
                    : plan.recommended
                    ? 'bg-accent text-accent-foreground hover:opacity-90'
                    : 'bg-primary text-primary-foreground hover:opacity-90'
                }`}
              >
                {plan.current ? 'Plan actuel' : 'Choisir ce plan'}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            Les paiements seront disponibles prochainement via Mobile Money (M-Pesa, Orange Money, Africell)
          </p>
        </div>
      </div>
    </div>
  );
};
